module.exports = __webpack_public_path__ + "static/media/phone-green.e5819023.svg";